import { ISchedulesTableInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const schedulesSelector = (state: RootState) => state.schedules;

const schedulesTableListSelector = createSelector([schedulesSelector], (schedules: ISchedulesTableInitialState) => schedules.schedulesTableList);
const vehicleSelector = createSelector([schedulesSelector], (schedules: ISchedulesTableInitialState) => schedules.vehicle);

export const schedulesSel = {
    schedulesSelector,
    schedulesTableListSelector,
    vehicleSelector,
};
